import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-papi-types';
import { actionKey } from '../constants';
import { OriginalDeviationFormFields } from '../../modals/OriginalDeviationPopup/types';

export const createOriginalDeviation = createAction(
  `${actionKey}.CREATE_ORIGINAL_DEVIATION`,
  (payload: {
    formData: OriginalDeviationFormFields;
    onSuccess?: (originalDeviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const updateOriginalDeviation = createAction(
  `${actionKey}.UPDATE_ORIGINAL_DEVIATION`,
  (payload: {
    deviationId: number;
    formData: OriginalDeviationFormFields;
    onSuccess?: (originalDeviation: PapiDeviation) => void;
    onError?: (response: any) => void;
  }) => payload
);

export const publishOriginalDeviation = createAction(
  `${actionKey}.PUBLISH_ORIGINAL_DEVIATION`,
  (payload: {
    deviationId: number;
    onSuccess?: () => void;
    onError?: (response: any) => void;
  }) => payload
);
